<locations-mobile-component *ngIf="template === 'mobile'"></locations-mobile-component>
<locations-desktop-component *ngIf="template === 'desktop'"></locations-desktop-component>

